<div class="row" id="DiscountTable">

  <div class="col-lg-12 ">
    <div class="row mx-0 justify-content-between align-items-center sameWidthBtn">
      <h5 class="ssm-page-heading2 mb-0 p-0" i18n="@@Merchandise_Discounts">Merchandise Discounts</h5>
      <button type="button" class="btn btn-primary" i18n="@New" (click)="onNewDiscount()"
      permissionHandler [functId]="32" [action]="eNumActionTypes.CREATE" [elementType]="eNumElementTypes.BUTTON" >New</button>
    </div>
  </div>



  <div id="tableScrollable" class="scrollit col-lg-12 mt-2">
    <table #grid class="table bg-white table-striped fixed_headers Discount-Table mb-0">
      <thead>
        <tr>
          <th>
            <label class="pure-material-checkbox mt-1">
              <input class="checkBoxClass" type="checkbox" [checked]="isAllChecked()" (change)="checkAll($event)">
              <span></span>
            </label>
          </th>
          <th i18n="@Discount_Name">Discount Name</th>
        </tr>
      </thead>
      <tbody>
        @for (item of DiscountList; track item) {
          <tr>
            <td>
              <label class="pure-material-checkbox ">
                <input type="checkbox" [checked]="item.Active" [(ngModel)]="item.Active"
                  [ngModelOptions]="{standalone: true}" (change)="checked($event)">
                  <span></span>
                </label>
              </td>
              <td>{{item.Name}}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <ng-template #templatemyModal>
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title" i18n="@Create_New_Discount">Create Discount</h5>
        <button type="button" class="close" (click)="confirmCancelForm(templateConfirm)">&times;</button>
      </div>


      <div class="modal-body common_form">
        <form [formGroup]="discountForm" (ngSubmit)="onDiscountSubmit()" novalidate>
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <div class="row mt-2">
                <div class="col-lg-3 pr-0">
                  <label i18n="@Name">Name
                  <span isMandatory [fieldName]="'Name'" [RequiredList]="discountReqList" class="required">*</span>
                </label>
                </div>
                <div class="col-lg-7">
                  <input type="text" class="form-control" formControlName="Name" maxlength="35" #DiscountName
                    (blur)="onBlurDiscountName($event.target.value)">
                    @if (isDiscountNameExist) {
                      <div class="alert alert-danger">
                        @if (isDiscountNameExist) {
                          <span i18n="@@Discount_name_exists"> Discount Name
                    {{discountForm.value.Name }} already exists!</span>
                        }
                      </div>
                    }
                    @if (discountForm.get('Name').errors  && (discountForm.get('Name').dirty || discountForm.get('Name').touched)) {
                      <div class="alert alert-danger"
                        >
                        @if (discountForm.get('Name').errors.required) {
                          <span i18n="@Discount_Name_is_required"> Discount
                    Name is required</span>
                        }
                        @if ( (discountForm.get('Name').errors.whitespace) && discountForm.get('Name').dirty) {
                          <span
                          i18n="@Invalid_input"> Invalid input </span>
                        }
                      </div>
                    }
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-3 pr-0">
                    <label i18n="@Description">Description
                  <span isMandatory [fieldName]="'Description'" [RequiredList]="discountReqList"
                    class="required">*</span>
                </label>
                  </div>
                  <div class="col-lg-7">
                    <input type="text" class="form-control" formControlName="Description" maxlength="500">
                    @if (discountForm.get('Description').errors  && (discountForm.get('Description').dirty || discountForm.get('Description').touched)) {
                      <div class="alert alert-danger"
                        >
                        @if (discountForm.get('Description').errors.required) {
                          <span i18n="@Description_is_required">
                    Description is required</span>
                        }
                        @if ( (discountForm.get('Description').errors.whitespace) && discountForm.get('Description').dirty) {
                          <span
                            >
                          Invalid input </span>
                        }
                      </div>
                    }
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-3 pr-0">
                    <label i18n="@Type">Type
                  <span isMandatory [fieldName]="'Type'" [RequiredList]="discountReqList" class="required">*</span>
                </label>
                  </div>
                  <div class="col-lg-7">
                    <select id="Type" class="form-select w-100" formControlName="Type" required>
                      <option [value]="null" disabled="true" [selected]="true" i18n="@@Select" hidden>Select</option>
                      <option [value]="EnumMerchDiscount.Percentage">{{EnumMerchDiscount[EnumMerchDiscount.Percentage]}}</option>
                      <option [value]="EnumMerchDiscount.Fixed">{{EnumMerchDiscount[EnumMerchDiscount.Fixed]}}
                      </option>
                    </select>
                    @if (discountForm.get('Type').errors  && (discountForm.get('Type').dirty || discountForm.get('Type').touched)) {
                      <div class="alert alert-danger"
                        >
                        @if (discountForm.get('Type').errors.required) {
                          <span> Type is required</span>
                        }
                      </div>
                    }
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-3 pr-0">
                    <label i18n="@Value">Value
                  <span isMandatory [fieldName]="'Value'" [RequiredList]="discountReqList" class="required">*</span>
                </label>
                  </div>
                  <div class="col-lg-7">
                    <input type="text" class="form-control" formControlName="Value" required (change)="discValuechanged()"
                      onkeypress="if (event.charCode > 31 && (event.charCode < 48 || event.charCode > 57) && event.charCode != 46) { return false;} else { return true;}">
                      @if (discountForm.get('Value').errors  && (discountForm.get('Value').dirty || discountForm.get('Value').touched)) {
                        <div class="alert alert-danger"
                          >
                          @if (discountForm.get('Value').errors.required) {
                            <span i18n="@Value_is_required">Value is
                    required</span>
                          }
                          @if (discountForm.get('Value').errors.pattern) {
                            <span i18n="@@Invaid_input" i18n="@Name">Invalid
                    input</span>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-3 pr-0">
                      <label i18n="@Start_Date">Start Date
                  <span isMandatory [fieldName]="'StartDate'" [RequiredList]="discountReqList" class="required">*</span>
                </label>
                    </div>
                    <div class="col-lg-7">
                      <ejs-datepicker Class="form-control p-0 h-auto" formControlName="StartDate" name="StartDate"
                        [min]='startMinDate' format='MM/dd/yyyy' floatLabelType='Always'
                        (change)="changeStartDate($event.value)">
                      </ejs-datepicker>
                      @if (discountForm.get('StartDate').errors  && ( discountForm.get('StartDate').touched)) {
                        <div class="alert alert-danger"
                          >
                          @if (discountForm.get('StartDate').errors.required) {
                            <span i18n="@Start_Date_is_required"> Start Date
                    is required</span>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-3 pr-0">
                      <label i18n="@End_Date">End Date
                  <span isMandatory [fieldName]="'EndDate'" [RequiredList]="discountReqList" class="required">*</span>
                </label>
                    </div>
                    <div class="col-lg-7">
                      <ejs-datepicker Class="form-control p-0 h-auto" formControlName="EndDate" name="EndDate" [min]='endMinDate'
                        format='MM/dd/yyyy' floatLabelType='Always'>
                      </ejs-datepicker>
                      @if (discountForm.get('EndDate').errors  && ( discountForm.get('EndDate').touched)) {
                        <div class="alert alert-danger"
                          >
                          @if (discountForm.get('EndDate').errors.required) {
                            <span i18n="@End_Date_is_required"> End Date is
                    required</span>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-3 pr-0">
                      <label i18n="@Account_Head">Account Head
                  <span isMandatory [fieldName]="'AccountsHead'" [RequiredList]="discountReqList"
                    class="required">*</span>
                </label>
                    </div>
                    <div class="col-lg-7">
                      <select id="competitorCompany" class="form-select" formControlName="AccountsHead" required>
                        <!-- <option value="">Select</option> -->
                        @for (item of AccountHeads; track item) {
                          <option [value]="item.Id">{{item.Name}}</option>
                        }
                      </select>
                      @if (discountForm.get('AccountsHead').errors  && (discountForm.get('AccountsHead').dirty || discountForm.get('AccountsHead').touched)) {
                        <div class="alert alert-danger"
                          >
                          @if (discountForm.get('AccountsHead').errors.required) {
                            <span i18n="@Account_Head_is_required">
                    Account Head is required</span>
                          }
                        </div>
                      }

                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-6">
                      <label class="pure-material-checkbox float-left m-0">
                        <input type="checkbox" id="listStore6Check" class="checkBoxClass" formControlName="ApplyatMoveIn">
                        <span class="colorgreen" i18n="@Apply_at_Move-in">Apply at Move-in</span>
                      </label>
                    </div>
                    <div class="col-lg-6 mt-2 mt-lg-0">
                      <label class="pure-material-checkbox float-left m-0">
                        <input type="checkbox" id="listStore6Check" class="checkBoxClass" formControlName="ApplyatTransfer">
                        <span class="colorgreen" i18n="@Apply_at_Transfer">Apply at Transfer </span>
                      </label>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-6">
                      <label class="pure-material-checkbox float-left m-0">
                        <input type="checkbox" id="listStore6Check" class="checkBoxClass"
                          formControlName="ApplytoExistingTenants">
                          <span class="colorgreen" i18n="@Apply_for_Existing_Tenants">Apply for Existing Tenants </span>
                        </label>
                      </div>
                      <div class="col-lg-6 mt-2 mt-lg-0">
                        <label class="pure-material-checkbox float-left m-0">
                          <input type="checkbox" id="listStore6Check" class="checkBoxClass"
                            formControlName="ApplytorWalkInCustomers">
                            <span class="colorgreen" i18n="@Apply_for_Walk-In_Customers">Apply for Walk-In Customers</span>
                          </label>
                        </div>
                      </div>
                      <div class="row mt-3">
                        <div class="col-lg-6">
                          <div class="md-radio">
                            <input id="1" type="radio" [value]="true" formControlName="ApplyAutomatically" checked>
                            <label for="1" i18n="@Apply_Automatically" class="mt-0">Apply Automatically</label>
                          </div>
                        </div>
                        <div class="col-lg-6 mt-2 mt-lg-0">
                          <div class="md-radio">
                            <input id="2" type="radio" [value]="false" formControlName="ApplyAutomatically">
                            <label for="2" i18n="@Apply_Manually" class="mt-0">Apply Manually </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-6">
                      <div class="row mt-2">
                        <div class="col-lg-3">
                          <label i18n="@Remarks" class="w-100 text-left text-lg-right">Remarks
                  <span isMandatory [fieldName]="'Remarks'" [RequiredList]="discountReqList" class="required">*</span>
                </label>
                        </div>
                        <div class="col-lg-9">
                          <textarea class="form-control" cols="15" rows="5" formControlName="Remarks"></textarea>
                          @if ((discountForm.get('Remarks').errors || discountForm.get('Remarks').value == '')  && ( discountForm.get('Remarks').touched)) {
                            <div isMandatory [fieldName]="'Remarks'" [RequiredList]="discountReqList" class="d-flex"
                              >
                              <span isMandatory [fieldName]="'Remarks'" [RequiredList]="discountReqList" class="alert alert-danger"
                              i18n="@Remarks_is_required"> Remarks is required</span>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div class="modal-footer">
                <button type="button" #fileInput class="btn btn-outline-primary mr-3" (click)="confirmCancelForm(templateConfirm)"
                i18n="@Cancel">Cancel</button>
                <button type="button" class="btn btn-primary" [disabled]="(!discountForm.valid || isDiscountNameExist)"
                (click)="onDiscountSubmit()" i18n="@Save">Save</button>
              </div>



            </div>
          </ng-template>

          <ng-template #templateDiscApplyOptions>
            <div class="modal-body py-4 text-center">
              <p class="mb-0" i18n="@@PleaseSelect_OneHighlighted_Green">Please select at least one Apply option highlighted in
      green.</p>
              <button type="button" class="btn btn-primary mt-4 w-25" (click)="validtaionModalRef.hide()" i18n="@@Ok">OK</button>
            </div>
          </ng-template>

          <ng-template #templatePercentageValidation>
            <div class="modal-body py-4 text-center">
              <p class="mb-0" i18n="@@Validation_Percentage">Value should be greater than 0 and less than or equal to 100</p>
              <button type="button" class="btn btn-primary mt-4 w-25" (click)="validtaionModalRef.hide()" i18n="@@Ok">OK</button>
            </div>
          </ng-template>

          <ng-template #templateFixedValidation>
            <div class="modal-body py-4 text-center">
              <p class="mb-0" i18n="@@Validation_Fixed">Value should be greater than 0</p>
              <button type="button" class="btn btn-primary mt-4 w-25" (click)="validtaionModalRef.hide()" i18n="@@Ok">OK</button>
            </div>
          </ng-template>

          <ng-template #templateConfirm>
            <div class="modal-header">
              <h5 class="modal-title" i18n="@@Confirm">Confirm</h5>
              <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body py-4">
              <p class="mb-0" i18n="@@Sure_discard">
      Are you sure you want to cancel? Any data modifications will not be saved
    </p>
            </div>
            <div class="modal-footer">
              <button class="btn btn-outline-primary mr-3" type="button" (click)="modalRef.hide();" i18n="@@No">No</button>
              <button class="btn btn-primary" type="button" (click)="returnToPopup()" i18n="@@Yes">Yes</button>
            </div>
          </ng-template>